import Vue from 'vue'
import VueRouter from 'vue-router'
import { constantRouterMap } from './router.config'

// hack router push/replace callback
['push', 'replace'].map(key => {
  return {
    k: key,
    prop: VueRouter.prototype[key]
  }
}).forEach(item => {
  VueRouter.prototype[item.k] = function newCall (location, onResolve, onReject) {
    if (onResolve || onReject) return item.prop.call(this, location, onResolve, onReject)
    return item.prop.call(this, location).catch(err => err)
  }
})

Vue.use(VueRouter)
const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
const router = createRouter()
// 去除路由重复的问题
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}
// 清空路由方法
router.selfaddRoutes = (params) => {
  router.matcher = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
  }).matcher
  router.addRoutes(params)
  // resetRouter()
}

export default router
